import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../base/common/strings.js';
import { SingleCursorState } from './cursorCommon.js';
import { getMapForWordSeparators } from './wordCharacterClassifier.js';
import { Position } from '../core/position.js';
import { Range } from '../core/range.js';
export var WordOperations = /*#__PURE__*/function () {
  function WordOperations() {
    _classCallCheck(this, WordOperations);
  }

  _createClass(WordOperations, null, [{
    key: "_createWord",
    value: function _createWord(lineContent, wordType, nextCharClass, start, end) {
      // console.log('WORD ==> ' + start + ' => ' + end + ':::: <<<' + lineContent.substring(start, end) + '>>>');
      return {
        start: start,
        end: end,
        wordType: wordType,
        nextCharClass: nextCharClass
      };
    }
  }, {
    key: "_findPreviousWordOnLine",
    value: function _findPreviousWordOnLine(wordSeparators, model, position) {
      var lineContent = model.getLineContent(position.lineNumber);
      return this._doFindPreviousWordOnLine(lineContent, wordSeparators, position);
    }
  }, {
    key: "_doFindPreviousWordOnLine",
    value: function _doFindPreviousWordOnLine(lineContent, wordSeparators, position) {
      var wordType = 0
      /* None */
      ;

      for (var chIndex = position.column - 2; chIndex >= 0; chIndex--) {
        var chCode = lineContent.charCodeAt(chIndex);
        var chClass = wordSeparators.get(chCode);

        if (chClass === 0
        /* Regular */
        ) {
          if (wordType === 2
          /* Separator */
          ) {
            return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
          }

          wordType = 1
          /* Regular */
          ;
        } else if (chClass === 2
        /* WordSeparator */
        ) {
          if (wordType === 1
          /* Regular */
          ) {
            return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
          }

          wordType = 2
          /* Separator */
          ;
        } else if (chClass === 1
        /* Whitespace */
        ) {
          if (wordType !== 0
          /* None */
          ) {
            return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
          }
        }
      }

      if (wordType !== 0
      /* None */
      ) {
        return this._createWord(lineContent, wordType, 1
        /* Whitespace */
        , 0, this._findEndOfWord(lineContent, wordSeparators, wordType, 0));
      }

      return null;
    }
  }, {
    key: "_findEndOfWord",
    value: function _findEndOfWord(lineContent, wordSeparators, wordType, startIndex) {
      var len = lineContent.length;

      for (var chIndex = startIndex; chIndex < len; chIndex++) {
        var chCode = lineContent.charCodeAt(chIndex);
        var chClass = wordSeparators.get(chCode);

        if (chClass === 1
        /* Whitespace */
        ) {
          return chIndex;
        }

        if (wordType === 1
        /* Regular */
        && chClass === 2
        /* WordSeparator */
        ) {
          return chIndex;
        }

        if (wordType === 2
        /* Separator */
        && chClass === 0
        /* Regular */
        ) {
          return chIndex;
        }
      }

      return len;
    }
  }, {
    key: "_findNextWordOnLine",
    value: function _findNextWordOnLine(wordSeparators, model, position) {
      var lineContent = model.getLineContent(position.lineNumber);
      return this._doFindNextWordOnLine(lineContent, wordSeparators, position);
    }
  }, {
    key: "_doFindNextWordOnLine",
    value: function _doFindNextWordOnLine(lineContent, wordSeparators, position) {
      var wordType = 0
      /* None */
      ;
      var len = lineContent.length;

      for (var chIndex = position.column - 1; chIndex < len; chIndex++) {
        var chCode = lineContent.charCodeAt(chIndex);
        var chClass = wordSeparators.get(chCode);

        if (chClass === 0
        /* Regular */
        ) {
          if (wordType === 2
          /* Separator */
          ) {
            return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
          }

          wordType = 1
          /* Regular */
          ;
        } else if (chClass === 2
        /* WordSeparator */
        ) {
          if (wordType === 1
          /* Regular */
          ) {
            return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
          }

          wordType = 2
          /* Separator */
          ;
        } else if (chClass === 1
        /* Whitespace */
        ) {
          if (wordType !== 0
          /* None */
          ) {
            return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
          }
        }
      }

      if (wordType !== 0
      /* None */
      ) {
        return this._createWord(lineContent, wordType, 1
        /* Whitespace */
        , this._findStartOfWord(lineContent, wordSeparators, wordType, len - 1), len);
      }

      return null;
    }
  }, {
    key: "_findStartOfWord",
    value: function _findStartOfWord(lineContent, wordSeparators, wordType, startIndex) {
      for (var chIndex = startIndex; chIndex >= 0; chIndex--) {
        var chCode = lineContent.charCodeAt(chIndex);
        var chClass = wordSeparators.get(chCode);

        if (chClass === 1
        /* Whitespace */
        ) {
          return chIndex + 1;
        }

        if (wordType === 1
        /* Regular */
        && chClass === 2
        /* WordSeparator */
        ) {
          return chIndex + 1;
        }

        if (wordType === 2
        /* Separator */
        && chClass === 0
        /* Regular */
        ) {
          return chIndex + 1;
        }
      }

      return 0;
    }
  }, {
    key: "moveWordLeft",
    value: function moveWordLeft(wordSeparators, model, position, wordNavigationType) {
      var lineNumber = position.lineNumber;
      var column = position.column;

      if (column === 1) {
        if (lineNumber > 1) {
          lineNumber = lineNumber - 1;
          column = model.getLineMaxColumn(lineNumber);
        }
      }

      var prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position(lineNumber, column));

      if (wordNavigationType === 0
      /* WordStart */
      ) {
        return new Position(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
      }

      if (wordNavigationType === 1
      /* WordStartFast */
      ) {
        if (prevWordOnLine && prevWordOnLine.wordType === 2
        /* Separator */
        && prevWordOnLine.end - prevWordOnLine.start === 1 && prevWordOnLine.nextCharClass === 0
        /* Regular */
        ) {
          // Skip over a word made up of one single separator and followed by a regular character
          prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position(lineNumber, prevWordOnLine.start + 1));
        }

        return new Position(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
      }

      if (wordNavigationType === 3
      /* WordAccessibility */
      ) {
        while (prevWordOnLine && prevWordOnLine.wordType === 2
        /* Separator */
        ) {
          // Skip over words made up of only separators
          prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position(lineNumber, prevWordOnLine.start + 1));
        }

        return new Position(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
      } // We are stopping at the ending of words


      if (prevWordOnLine && column <= prevWordOnLine.end + 1) {
        prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position(lineNumber, prevWordOnLine.start + 1));
      }

      return new Position(lineNumber, prevWordOnLine ? prevWordOnLine.end + 1 : 1);
    }
  }, {
    key: "_moveWordPartLeft",
    value: function _moveWordPartLeft(model, position) {
      var lineNumber = position.lineNumber;
      var maxColumn = model.getLineMaxColumn(lineNumber);

      if (position.column === 1) {
        return lineNumber > 1 ? new Position(lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)) : position;
      }

      var lineContent = model.getLineContent(lineNumber);

      for (var column = position.column - 1; column > 1; column--) {
        var left = lineContent.charCodeAt(column - 2);
        var right = lineContent.charCodeAt(column - 1);

        if (left === 95
        /* Underline */
        && right !== 95
        /* Underline */
        ) {
          // snake_case_variables
          return new Position(lineNumber, column);
        }

        if (strings.isLowerAsciiLetter(left) && strings.isUpperAsciiLetter(right)) {
          // camelCaseVariables
          return new Position(lineNumber, column);
        }

        if (strings.isUpperAsciiLetter(left) && strings.isUpperAsciiLetter(right)) {
          // thisIsACamelCaseWithOneLetterWords
          if (column + 1 < maxColumn) {
            var rightRight = lineContent.charCodeAt(column);

            if (strings.isLowerAsciiLetter(rightRight)) {
              return new Position(lineNumber, column);
            }
          }
        }
      }

      return new Position(lineNumber, 1);
    }
  }, {
    key: "moveWordRight",
    value: function moveWordRight(wordSeparators, model, position, wordNavigationType) {
      var lineNumber = position.lineNumber;
      var column = position.column;
      var movedDown = false;

      if (column === model.getLineMaxColumn(lineNumber)) {
        if (lineNumber < model.getLineCount()) {
          movedDown = true;
          lineNumber = lineNumber + 1;
          column = 1;
        }
      }

      var nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, column));

      if (wordNavigationType === 2
      /* WordEnd */
      ) {
        if (nextWordOnLine && nextWordOnLine.wordType === 2
        /* Separator */
        ) {
          if (nextWordOnLine.end - nextWordOnLine.start === 1 && nextWordOnLine.nextCharClass === 0
          /* Regular */
          ) {
            // Skip over a word made up of one single separator and followed by a regular character
            nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, nextWordOnLine.end + 1));
          }
        }

        if (nextWordOnLine) {
          column = nextWordOnLine.end + 1;
        } else {
          column = model.getLineMaxColumn(lineNumber);
        }
      } else if (wordNavigationType === 3
      /* WordAccessibility */
      ) {
        if (movedDown) {
          // If we move to the next line, pretend that the cursor is right before the first character.
          // This is needed when the first word starts right at the first character - and in order not to miss it,
          // we need to start before.
          column = 0;
        }

        while (nextWordOnLine && (nextWordOnLine.wordType === 2
        /* Separator */
        || nextWordOnLine.start + 1 <= column)) {
          // Skip over a word made up of one single separator
          // Also skip over word if it begins before current cursor position to ascertain we're moving forward at least 1 character.
          nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, nextWordOnLine.end + 1));
        }

        if (nextWordOnLine) {
          column = nextWordOnLine.start + 1;
        } else {
          column = model.getLineMaxColumn(lineNumber);
        }
      } else {
        if (nextWordOnLine && !movedDown && column >= nextWordOnLine.start + 1) {
          nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, nextWordOnLine.end + 1));
        }

        if (nextWordOnLine) {
          column = nextWordOnLine.start + 1;
        } else {
          column = model.getLineMaxColumn(lineNumber);
        }
      }

      return new Position(lineNumber, column);
    }
  }, {
    key: "_moveWordPartRight",
    value: function _moveWordPartRight(model, position) {
      var lineNumber = position.lineNumber;
      var maxColumn = model.getLineMaxColumn(lineNumber);

      if (position.column === maxColumn) {
        return lineNumber < model.getLineCount() ? new Position(lineNumber + 1, 1) : position;
      }

      var lineContent = model.getLineContent(lineNumber);

      for (var column = position.column + 1; column < maxColumn; column++) {
        var left = lineContent.charCodeAt(column - 2);
        var right = lineContent.charCodeAt(column - 1);

        if (left !== 95
        /* Underline */
        && right === 95
        /* Underline */
        ) {
          // snake_case_variables
          return new Position(lineNumber, column);
        }

        if (strings.isLowerAsciiLetter(left) && strings.isUpperAsciiLetter(right)) {
          // camelCaseVariables
          return new Position(lineNumber, column);
        }

        if (strings.isUpperAsciiLetter(left) && strings.isUpperAsciiLetter(right)) {
          // thisIsACamelCaseWithOneLetterWords
          if (column + 1 < maxColumn) {
            var rightRight = lineContent.charCodeAt(column);

            if (strings.isLowerAsciiLetter(rightRight)) {
              return new Position(lineNumber, column);
            }
          }
        }
      }

      return new Position(lineNumber, maxColumn);
    }
  }, {
    key: "_deleteWordLeftWhitespace",
    value: function _deleteWordLeftWhitespace(model, position) {
      var lineContent = model.getLineContent(position.lineNumber);
      var startIndex = position.column - 2;
      var lastNonWhitespace = strings.lastNonWhitespaceIndex(lineContent, startIndex);

      if (lastNonWhitespace + 1 < startIndex) {
        return new Range(position.lineNumber, lastNonWhitespace + 2, position.lineNumber, position.column);
      }

      return null;
    }
  }, {
    key: "deleteWordLeft",
    value: function deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      if (!selection.isEmpty()) {
        return selection;
      }

      var position = new Position(selection.positionLineNumber, selection.positionColumn);
      var lineNumber = position.lineNumber;
      var column = position.column;

      if (lineNumber === 1 && column === 1) {
        // Ignore deleting at beginning of file
        return null;
      }

      if (whitespaceHeuristics) {
        var r = this._deleteWordLeftWhitespace(model, position);

        if (r) {
          return r;
        }
      }

      var prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);

      if (wordNavigationType === 0
      /* WordStart */
      ) {
        if (prevWordOnLine) {
          column = prevWordOnLine.start + 1;
        } else {
          if (column > 1) {
            column = 1;
          } else {
            lineNumber--;
            column = model.getLineMaxColumn(lineNumber);
          }
        }
      } else {
        if (prevWordOnLine && column <= prevWordOnLine.end + 1) {
          prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position(lineNumber, prevWordOnLine.start + 1));
        }

        if (prevWordOnLine) {
          column = prevWordOnLine.end + 1;
        } else {
          if (column > 1) {
            column = 1;
          } else {
            lineNumber--;
            column = model.getLineMaxColumn(lineNumber);
          }
        }
      }

      return new Range(lineNumber, column, position.lineNumber, position.column);
    }
  }, {
    key: "_deleteWordPartLeft",
    value: function _deleteWordPartLeft(model, selection) {
      if (!selection.isEmpty()) {
        return selection;
      }

      var pos = selection.getPosition();

      var toPosition = WordOperations._moveWordPartLeft(model, pos);

      return new Range(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
    }
  }, {
    key: "_findFirstNonWhitespaceChar",
    value: function _findFirstNonWhitespaceChar(str, startIndex) {
      var len = str.length;

      for (var chIndex = startIndex; chIndex < len; chIndex++) {
        var ch = str.charAt(chIndex);

        if (ch !== ' ' && ch !== '\t') {
          return chIndex;
        }
      }

      return len;
    }
  }, {
    key: "_deleteWordRightWhitespace",
    value: function _deleteWordRightWhitespace(model, position) {
      var lineContent = model.getLineContent(position.lineNumber);
      var startIndex = position.column - 1;

      var firstNonWhitespace = this._findFirstNonWhitespaceChar(lineContent, startIndex);

      if (startIndex + 1 < firstNonWhitespace) {
        // bingo
        return new Range(position.lineNumber, position.column, position.lineNumber, firstNonWhitespace + 1);
      }

      return null;
    }
  }, {
    key: "deleteWordRight",
    value: function deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      if (!selection.isEmpty()) {
        return selection;
      }

      var position = new Position(selection.positionLineNumber, selection.positionColumn);
      var lineNumber = position.lineNumber;
      var column = position.column;
      var lineCount = model.getLineCount();
      var maxColumn = model.getLineMaxColumn(lineNumber);

      if (lineNumber === lineCount && column === maxColumn) {
        // Ignore deleting at end of file
        return null;
      }

      if (whitespaceHeuristics) {
        var r = this._deleteWordRightWhitespace(model, position);

        if (r) {
          return r;
        }
      }

      var nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);

      if (wordNavigationType === 2
      /* WordEnd */
      ) {
        if (nextWordOnLine) {
          column = nextWordOnLine.end + 1;
        } else {
          if (column < maxColumn || lineNumber === lineCount) {
            column = maxColumn;
          } else {
            lineNumber++;
            nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, 1));

            if (nextWordOnLine) {
              column = nextWordOnLine.start + 1;
            } else {
              column = model.getLineMaxColumn(lineNumber);
            }
          }
        }
      } else {
        if (nextWordOnLine && column >= nextWordOnLine.start + 1) {
          nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, nextWordOnLine.end + 1));
        }

        if (nextWordOnLine) {
          column = nextWordOnLine.start + 1;
        } else {
          if (column < maxColumn || lineNumber === lineCount) {
            column = maxColumn;
          } else {
            lineNumber++;
            nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position(lineNumber, 1));

            if (nextWordOnLine) {
              column = nextWordOnLine.start + 1;
            } else {
              column = model.getLineMaxColumn(lineNumber);
            }
          }
        }
      }

      return new Range(lineNumber, column, position.lineNumber, position.column);
    }
  }, {
    key: "_deleteWordPartRight",
    value: function _deleteWordPartRight(model, selection) {
      if (!selection.isEmpty()) {
        return selection;
      }

      var pos = selection.getPosition();

      var toPosition = WordOperations._moveWordPartRight(model, pos);

      return new Range(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
    }
  }, {
    key: "_createWordAtPosition",
    value: function _createWordAtPosition(model, lineNumber, word) {
      var range = new Range(lineNumber, word.start + 1, lineNumber, word.end + 1);
      return {
        word: model.getValueInRange(range),
        startColumn: range.startColumn,
        endColumn: range.endColumn
      };
    }
  }, {
    key: "getWordAtPosition",
    value: function getWordAtPosition(model, _wordSeparators, position) {
      var wordSeparators = getMapForWordSeparators(_wordSeparators);

      var prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);

      if (prevWord && prevWord.wordType === 1
      /* Regular */
      && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) {
        return WordOperations._createWordAtPosition(model, position.lineNumber, prevWord);
      }

      var nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);

      if (nextWord && nextWord.wordType === 1
      /* Regular */
      && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) {
        return WordOperations._createWordAtPosition(model, position.lineNumber, nextWord);
      }

      return null;
    }
  }, {
    key: "word",
    value: function word(config, model, cursor, inSelectionMode, position) {
      var wordSeparators = getMapForWordSeparators(config.wordSeparators);

      var prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);

      var nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);

      if (!inSelectionMode) {
        // Entering word selection for the first time
        var _startColumn;

        var _endColumn;

        if (prevWord && prevWord.wordType === 1
        /* Regular */
        && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) {
          // isTouchingPrevWord
          _startColumn = prevWord.start + 1;
          _endColumn = prevWord.end + 1;
        } else if (nextWord && nextWord.wordType === 1
        /* Regular */
        && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) {
          // isTouchingNextWord
          _startColumn = nextWord.start + 1;
          _endColumn = nextWord.end + 1;
        } else {
          if (prevWord) {
            _startColumn = prevWord.end + 1;
          } else {
            _startColumn = 1;
          }

          if (nextWord) {
            _endColumn = nextWord.start + 1;
          } else {
            _endColumn = model.getLineMaxColumn(position.lineNumber);
          }
        }

        return new SingleCursorState(new Range(position.lineNumber, _startColumn, position.lineNumber, _endColumn), 0, new Position(position.lineNumber, _endColumn), 0);
      }

      var startColumn;
      var endColumn;

      if (prevWord && prevWord.wordType === 1
      /* Regular */
      && prevWord.start < position.column - 1 && position.column - 1 < prevWord.end) {
        // isInsidePrevWord
        startColumn = prevWord.start + 1;
        endColumn = prevWord.end + 1;
      } else if (nextWord && nextWord.wordType === 1
      /* Regular */
      && nextWord.start < position.column - 1 && position.column - 1 < nextWord.end) {
        // isInsideNextWord
        startColumn = nextWord.start + 1;
        endColumn = nextWord.end + 1;
      } else {
        startColumn = position.column;
        endColumn = position.column;
      }

      var lineNumber = position.lineNumber;
      var column;

      if (cursor.selectionStart.containsPosition(position)) {
        column = cursor.selectionStart.endColumn;
      } else if (position.isBeforeOrEqual(cursor.selectionStart.getStartPosition())) {
        column = startColumn;
        var possiblePosition = new Position(lineNumber, column);

        if (cursor.selectionStart.containsPosition(possiblePosition)) {
          column = cursor.selectionStart.endColumn;
        }
      } else {
        column = endColumn;

        var _possiblePosition = new Position(lineNumber, column);

        if (cursor.selectionStart.containsPosition(_possiblePosition)) {
          column = cursor.selectionStart.startColumn;
        }
      }

      return cursor.move(true, lineNumber, column, 0);
    }
  }]);

  return WordOperations;
}();
export var WordPartOperations = /*#__PURE__*/function (_WordOperations) {
  _inherits(WordPartOperations, _WordOperations);

  var _super = _createSuper(WordPartOperations);

  function WordPartOperations() {
    _classCallCheck(this, WordPartOperations);

    return _super.apply(this, arguments);
  }

  _createClass(WordPartOperations, null, [{
    key: "deleteWordPartLeft",
    value: function deleteWordPartLeft(wordSeparators, model, selection, whitespaceHeuristics) {
      var candidates = enforceDefined([WordOperations.deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, 0
      /* WordStart */
      ), WordOperations.deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, 2
      /* WordEnd */
      ), WordOperations._deleteWordPartLeft(model, selection)]);
      candidates.sort(Range.compareRangesUsingEnds);
      return candidates[2];
    }
  }, {
    key: "deleteWordPartRight",
    value: function deleteWordPartRight(wordSeparators, model, selection, whitespaceHeuristics) {
      var candidates = enforceDefined([WordOperations.deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, 0
      /* WordStart */
      ), WordOperations.deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, 2
      /* WordEnd */
      ), WordOperations._deleteWordPartRight(model, selection)]);
      candidates.sort(Range.compareRangesUsingStarts);
      return candidates[0];
    }
  }, {
    key: "moveWordPartLeft",
    value: function moveWordPartLeft(wordSeparators, model, position) {
      var candidates = enforceDefined([WordOperations.moveWordLeft(wordSeparators, model, position, 0
      /* WordStart */
      ), WordOperations.moveWordLeft(wordSeparators, model, position, 2
      /* WordEnd */
      ), WordOperations._moveWordPartLeft(model, position)]);
      candidates.sort(Position.compare);
      return candidates[2];
    }
  }, {
    key: "moveWordPartRight",
    value: function moveWordPartRight(wordSeparators, model, position) {
      var candidates = enforceDefined([WordOperations.moveWordRight(wordSeparators, model, position, 0
      /* WordStart */
      ), WordOperations.moveWordRight(wordSeparators, model, position, 2
      /* WordEnd */
      ), WordOperations._moveWordPartRight(model, position)]);
      candidates.sort(Position.compare);
      return candidates[0];
    }
  }]);

  return WordPartOperations;
}(WordOperations);

function enforceDefined(arr) {
  return arr.filter(function (el) {
    return Boolean(el);
  });
}